import React from 'react';
import MediaQuery from 'react-responsive';
import './CoCreation.css';

import topTriangles from '../../images/industry/top-triangles.png';
import innovationImg from '../../images/industry/imagemTrack.jpg';
import transferImg from '../../images/industry/imagemSiu.png';
import creationImg from '../../images/industry/imagemDark.png';
import consultancyImg from '../../images/industry/consultancy.jpg';
import unidadeEmbrapiiImg from '../../images/industry/logocompleta_embrapii.webp';

function CoCreationSection() {
  return (
    <div id="co-creation">
      <div id="top-banner">
        <img id="triangles" src={topTriangles} alt="" />
        <h2>
        Co-create
          <MediaQuery query="(min-width: 425px)">
            {' '}
          </MediaQuery>
          <MediaQuery query="(max-width: 425px)">
            <br />
          </MediaQuery>
          innovation based on cutting-edge technology,
          generating disruptive solutions for the market.
        </h2>
      </div>

      <div id="colabs-container">
        <div id="colabs-collection">
          <div className="colabs-collection">

            <div className="ColabCont">
              <div className="imagem"><img src={innovationImg} alt="" /></div>
              <div className="ColabText">
                <h1>Applied innovation</h1>
                <h2>
                  Exploring more efficient and effective technology applications
                  in solutions for the market through master&apos;s and PhD programs.
                </h2>
              </div>
            </div>

            <div className="ColabCont">
              <div className="imagem"><img src={transferImg} alt="" /></div>
              <div className="ColabText">
                <h1>Technology transfer</h1>
                <h2>
                  Development and adaptation of technologies and
                  platforms from our portfolio to meet market demands.
                </h2>
              </div>
            </div>

            <div className="ColabCont">
              <div className="imagem"><img src={creationImg} alt="" /></div>
              <div className="ColabText">
                <h1>Technology creation</h1>
                <h2>
                  Demand-driven development for specific challenges
                  from partners and clients.
                </h2>
              </div>
            </div>

            <div className="ColabCont">
              <div className="imagem"><img src={consultancyImg} alt="" /></div>
              <div className="ColabText">
                <h1>Consulting</h1>
                <h2>
                  Support and coverage regarding technology transfer, c
                  hallenge discovery, and technology applications.
                </h2>
              </div>
            </div>

            <div className="linha" />

            <div className="ColabCont">
              <div className="imagem"><img id="logo_embrapii" src={unidadeEmbrapiiImg} alt="" /></div>
              <div className="ColabText">
                <h1>
                  Embrapii Unity
                </h1>
                <h2>
                  Embrapii partnering unit that fosters and encourages
                  projects with private initiative involved in
                  <span>vehicle technology</span>
                  .
                </h2>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default CoCreationSection;
